export const SEARCH_IRRELEVANCE_CAROUSEL_COMPONENT_NAME =
  "search_irrelevance_carousel";
